import React from 'react';
import { Button, Typography, recessColors } from '@guildeducationinc/recess';
import ErrorOutlineIcon from '@guildeducationinc/recess/icons/ErrorOutlineIcon';
import { clickable } from '@src/analytics';
import RequestSupportButton from '@shared/RequestSupportButton/RequestSupportButton';

interface ECornellCardProps {
  ssoLink?: string | null;
  programName?: string | null;
}

export const SIGN_IN_BUTTON_TEXT = 'Sign in';
export const ECORNELL_DESCRIPTION = 'Log into eCornell to start your program';
export const ECORNELL_ERROR_TITLE = 'There was a problem';
export const ECORNELL_ERROR_DESCRIPTION =
  "We couldn't load your eCornell course details. Contact Guild Support and we'll help get you back on track.";

export const ssoClickableProperties = {
  loggedIn: true,
  product: 'home',
  tag: '3rd_party_application-ecornell',
  text: 'sign_in',
  type: 'button',
};

const ECornellCard: React.FC<ECornellCardProps> = ({ ssoLink, programName }) => {
  const ProgramCard = (
    <>
      {programName ? <Typography variant='title3'>{programName}</Typography> : null}
      <Typography variant='body1' className='padding--bottom_16'>
        {ECORNELL_DESCRIPTION}
      </Typography>
      <Button
        className='padding--bottom_16'
        appearance='outline'
        href={ssoLink!}
        target='_blank'
        rel='noopener noreferrer'
        newWindowIcon={true}
        newWindowNotification={true}
        testid='ecornellLink'
        onClick={() => {
          clickable(ssoClickableProperties);
        }}
      >
        {SIGN_IN_BUTTON_TEXT}
      </Button>
    </>
  );

  const ErrorState = (
    <>
      <div className='flex'>
        <ErrorOutlineIcon
          size={20}
          color={recessColors.yellow.base}
          className='margin--4 margin--right_8'
        />
        <div>
          <Typography variant='title3'>{ECORNELL_ERROR_TITLE}</Typography>
          <Typography variant='body1' className='padding--bottom_16 padding--top_8'>
            {ECORNELL_ERROR_DESCRIPTION}
          </Typography>
        </div>
      </div>
      <RequestSupportButton appearance='outline' />
    </>
  );

  return <>{ssoLink ? ProgramCard : ErrorState}</>;
};

export default ECornellCard;
